import { NotificationConfiguration } from '../notification.templates';

export const SHARE_MEETING_AGENDA_TEMPLATE: NotificationConfiguration = {
  inapp: `<b>{triggeredByName}</b> shared a meeting agenda with you.`,
  email: {
    ctaKey: 'go_to_meeting_agenda',
  },
};
